import { motion, AnimatePresence } from "framer-motion";

const actionWords = [
  { label: "Innovate", className: "bg-violet-600" },
  { label: "Optimize", className: "bg-orange-600" },
  { label: "Empower", className: "bg-amber-400" },
  { label: "Collaborate", className: "bg-blue-600" },
];

function LoadingScreen({ isLoading }) {
  return (
    <AnimatePresence>
      {isLoading && (
        <motion.div
          className="fixed inset-0 z-[80] flex items-center justify-center bg-bee-bg px-5"
          initial={{ opacity: 1 }}
          exit={{ opacity: 0, transition: { duration: 0.5 } }}
        >
          <div className="flex w-full max-w-6xl flex-col items-center justify-center gap-9 md:flex-row md:justify-between md:gap-16">
            <motion.div
              className="grid w-full max-w-[330px] grid-cols-2 place-items-center gap-x-3 gap-y-3 sm:max-w-none sm:gap-x-5 sm:gap-y-4"
              initial="hidden"
              animate="visible"
              variants={{
                hidden: {},
                visible: {
                  transition: {
                    staggerChildren: 0.16,
                  },
                },
              }}
            >
              {actionWords.map((word, index) => (
                <motion.span
                  key={word.label}
                  className={`inline-flex min-h-12 max-w-full items-center justify-center rounded-xl px-3 text-xl font-black leading-none text-white shadow-[0_16px_38px_rgba(5,5,11,0.16)] min-[380px]:px-4 min-[380px]:text-2xl sm:min-h-16 sm:px-7 sm:text-4xl ${word.className} ${
                    index === 2 ? "col-start-1 translate-x-2 min-[380px]:translate-x-5 sm:translate-x-10" : ""
                  } ${index === 3 ? "col-start-2 -translate-x-1 sm:-translate-x-4" : ""}`}
                  variants={{
                    hidden: { opacity: 0, y: 26, scale: 0.78, rotate: -3 },
                    visible: {
                      opacity: 1,
                      y: 0,
                      scale: 1,
                      rotate: 0,
                      transition: { type: "spring", stiffness: 420, damping: 24 },
                    },
                  }}
                >
                  {word.label}
                </motion.span>
              ))}
            </motion.div>

            <motion.p
              className="flex max-w-full items-center gap-3 text-4xl font-black tracking-normal text-white min-[380px]:text-5xl sm:gap-4 sm:text-7xl lg:text-8xl"
              initial={{ opacity: 0, x: 34, scale: 0.94 }}
              animate={{ opacity: 1, x: 0, scale: 1 }}
              transition={{ delay: 0.72, duration: 0.62, ease: [0.16, 1, 0.3, 1] }}
            >
              <motion.span
                className="flex h-11 w-11 shrink-0 items-center justify-center min-[380px]:h-14 min-[380px]:w-14 sm:h-20 sm:w-20 lg:h-24 lg:w-24"
                animate={{ rotate: [0, 90, 180] }}
                transition={{ delay: 0.82, duration: 0.7, ease: "easeOut" }}
              >
                <svg viewBox="0 0 64 64" role="img" aria-hidden="true" className="h-full w-full">
                  <g fill="none" stroke="currentColor" strokeLinecap="square" strokeWidth="7">
                    <path d="M32 6v52" />
                    <path d="M6 32h52" />
                    <path d="M13.6 13.6l36.8 36.8" />
                    <path d="M50.4 13.6 13.6 50.4" />
                  </g>
                  <circle cx="32" cy="32" r="4.5" fill="currentColor" />
                </svg>
              </motion.span>
              <span>BeeVerge</span>
            </motion.p>
          </div>
        </motion.div>
      )}
    </AnimatePresence>
  );
}

export default LoadingScreen;
